module.exports = __webpack_public_path__ + "static/media/dwarf-helmet.3915616c.svg";